import { configureStore } from "@reduxjs/toolkit";
import homeReducer from "./features/homeSlice";
import toolsReducer from "./features/toolsSlice";
import plansReducer from "./features/plansSlice";
import dashboardReducer from "./features/dashboardSlice";
import termsReducer from "./features/termsSlice";
import prizeRulesReducer from "./features/prizeRulesSlice";


export const store = configureStore({
  reducer: {
    home: homeReducer,
    tools: toolsReducer,
    plans: plansReducer,
    dashboard: dashboardReducer,
    terms : termsReducer,
    prizeRules : prizeRulesReducer, 
  },
});
